module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: [{
      loading: _vm.list.loading
    }, 'ro-person-search']
  }, [_c('div', {
    staticClass: "search-form"
  }, [_c('form', {
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.update($event)
      }
    }
  }, [_vm._t("default", null, {
    data: _vm.parameters
  })], 2)]), _vm._v(" "), _c('div', {
    staticClass: "search-results"
  }, [_c('div', {
    staticClass: "grid-persons"
  }, [_c('ul', _vm._l((_vm.list.results.items), function(item, key) {
    return _c('li', {
      key: key
    }, [_c('div', [_c('strong', {
      domProps: {
        "textContent": _vm._s(item.name)
      }
    }), _vm._v(" "), _c('span', {
      domProps: {
        "textContent": _vm._s(item.data.jobTitle)
      }
    }), _c('br'), _vm._v(" "), (item.data.workPhone) ? _c('span', [_c('a', {
      attrs: {
        "href": ("tel:" + (item.data.workPhone))
      }
    }, [_vm._v(_vm._s(item.data.workPhone))]), _c('br')]) : _vm._e(), _vm._v(" "), _c('p', [_c('a', {
      attrs: {
        "href": ("mailto:" + (item.data.email))
      }
    }, [_vm._v(_vm._s(item.data.email))])])])])
  }))]), _vm._v(" "), (_vm.list.results.pagination.total > _vm.list.results.items.length) ? _c('div', {
    staticClass: "search-more"
  }, [(_vm.list.preferences.pagination && _vm.list.results.pagination.offset != 0) ? _c('button', {
    staticClass: "search-previous",
    domProps: {
      "innerHTML": _vm._s(_vm.messagePrevious)
    },
    on: {
      "click": _vm.previous
    }
  }) : _vm._e(), _vm._v(" "), (_vm.list.results.items.length >= _vm.list.results.pagination.limit) ? _c('button', {
    staticClass: "search-next",
    domProps: {
      "innerHTML": _vm._s(_vm.messageNext)
    },
    on: {
      "click": _vm.next
    }
  }) : _vm._e()]) : _vm._e()])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// /Users/fyrstenberg/Documents/Limbo/Roskilde-Handelsskole-Website-2023/frontend/~/vue-loader/lib/template-compiler.js?{"id":"data-v-0dc60e5c"}!./scripts/ro-person-search/RoPersonSearch.html
// module id = 363
// module chunks = 1